import { MouseEvent } from 'react';

import Check from '~components/Icon/Check';

import { TinyDropDownOption } from '..';
import * as S from './style';

interface Props extends TinyDropDownOption {
  onClick?: (value: string) => void;
}

export default function Option({ label, value, disabled, selected, onClick }: Props) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (disabled || selected) {
      return;
    }

    if (onClick) {
      onClick(value);
    }
  };

  return (
    <li>
      <S.Anchor disabled={disabled} selected={selected} onClick={handleClick} href='#'>
        {label}
        {selected && <Check />}
      </S.Anchor>
    </li>
  );
}
